import { render, staticRenderFns } from "./message.vue?vue&type=template&id=45741aca&scoped=true&"
import script from "./message.vue?vue&type=script&lang=ts&"
export * from "./message.vue?vue&type=script&lang=ts&"
import style0 from "./message.vue?vue&type=style&index=0&id=45741aca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45741aca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45741aca')) {
      api.createRecord('45741aca', component.options)
    } else {
      api.reload('45741aca', component.options)
    }
    module.hot.accept("./message.vue?vue&type=template&id=45741aca&scoped=true&", function () {
      api.rerender('45741aca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "module/Account/view/vue/components/message.vue"
export default component.exports